import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import actions from '../constants';

const useApplyRequestObjects = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ sections }) => handler({
    type: actions.APPLY_REQUEST_OBJECTS, category, code, sections,
  }), [category, code]);
};

const useAddRequestLink = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, sections }) => handler({
    type: actions.ADD_REQUEST_LINK, category, code, activeFieldName, sections,
  }), [category, code]);
};

const useShowRequestLinks = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, activeIndex, sections }) => handler({
    type: actions.SHOW_REQUEST_LINKS, category, code, activeFieldName, activeIndex, sections,
  }), [category, code]);
};

const useUpdateActiveRequestObject = () => {
  const handler = useDispatch();
  return useCallback(({ index }) => handler({ type: actions.UPDATE_ACTIVE_REQUEST_OBJECT, index }), []);
};

const useWithForm = (type) => {
  const handler = useDispatch();
  return useCallback(({ sections }) => handler({ type, sections }), []);
};

const useUpdateRequestObjectProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_REQUEST_OBJECT_PROPERTIES, properties,
  }), []);
};

const useUpdateRequestObjectsProperties = () => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_REQUEST_OBJECTS_PROPERTIES, properties,
  }), []);
};

const useAddRequestObject = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, sections }) => handler({
    type: actions.ADD_REQUEST_OBJECT, category, code, activeFieldName, sections,
  }), [category, code]);
};

const useDeleteRequestObject = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, activeIndex }) => handler({
    type: actions.DELETE_REQUEST_OBJECT, category, code, activeFieldName, activeIndex,
  }), [category, code]);
};

const useShowRequestObjects = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, activeIndex, sections }) => handler({
    type: actions.SHOW_REQUEST_OBJECTS, category, code, activeFieldName, activeIndex, sections,
  }), [category, code]);
};

const useUpdateRequestFieldsObjectProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ activeFieldName, activeIndex, properties }) => handler({
    type: actions.UPDATE_REQUEST_FIELDS_OBJECT_PROPERTIES,
    category,
    code,
    activeFieldName,
    activeIndex,
    properties,
  }), [category, code]);
};

export default {
  useAddRequestLink,
  useAddRequestObject,
  useApplyRequestObjects,
  useDeleteActiveRequestObject: () => events.useSimpleDispatch(actions.DELETE_ACTIVE_REQUEST_OBJECT),
  useDeleteRequestObject,
  useHideRequestObjects: () => events.useSimpleDispatch(actions.HIDE_REQUEST_OBJECTS),
  useInsertRequestLink: () => useWithForm(actions.INSERT_REQUEST_LINK),
  useInsertRequestObject: () => useWithForm(actions.INSERT_REQUEST_OBJECT),
  useShowRequestLinks,
  useShowRequestObjects,
  useUpdateActiveRequestObject,
  useUpdateRequestObjectProperties,
  useUpdateRequestObjectsProperties,
  useUpdateRequestFieldsObjectProperties,
};
